import angular from 'angular';

import { User } from '../types';

interface UserWithSelection extends User {
  selected?: boolean;
}

export class TasksOverviewCtrl {
  static $inject = ['TasksOverview', '$scope', '$translate'];

  users: UserWithSelection[] = [];
  selectedUsers: UserWithSelection[] = [];
  solvedToday = [];
  tasks = [];
  tabs: {
    title: string;
    filters: {
      solved: 0 | 1;
      relativeDate: 'today' | 'week' | 'month' | 'monthNext';
    };
    type: 'today' | 'week' | 'month' | 'monthNext';
  }[] = [];
  selectedIndex = 0;
  loaded = false;
  userIsExternalUser = false;

  constructor(
    private TasksOverview,
    $scope: angular.IScope,
    $translate,
  ) {
    this.tabs = [
      {
        title: $translate.instant('tasks.tabs.today'),
        filters: {
          solved: 0,
          relativeDate: 'today',
        },
        type: 'today',
      },
      {
        title: $translate.instant('tasks.tabs.this.week'),
        filters: {
          solved: 0,
          relativeDate: 'week',
        },
        type: 'week',
      },
      {
        title: $translate.instant('tasks.tabs.this.month'),
        filters: {
          solved: 0,
          relativeDate: 'month',
        },
        type: 'month',
      },
      {
        title: $translate.instant('tasks.tabs.next.month'),
        filters: {
          solved: 0,
          relativeDate: 'monthNext',
        },
        type: 'monthNext',
      },
    ];

    TasksOverview.getUsers({}, (resp) => {
      // select current user
      this.users = resp;

      if (this.users.length) {
        // Iterate users in sync mode
        for (let i = 0; i < this.users.length; i++) {
          this.users[i].selected = !!this.users[i].current;

          if (this.users[i].current && this.users[i].role === '1') {
            this.userIsExternalUser = true;
          }
        }

        // Once iterated - let user selector update itself (10ms timeout should be good)
        // And then start watching changes on tabs and user - this will avoid multiple api calls
        setTimeout(() => {
          this.getTasksForTab(this.selectedIndex);

          $scope.$watch('vm.selectedUsers', (n, o) => {
            if (angular.equals(n, o)) {
              return;
            }

            this.getTasksForTab(this.selectedIndex);
          });

          $scope.$watch('vm.selectedIndex', (current, old) => {
            // noinspection JSIncompatibleTypesComparison
            if (current === old) {
              return;
            }

            this.loaded = false;
            this.getTasksForTab(current);
          });

          $scope.$on(
            '$stateChangeSuccess',
            (event, toState, toParams, fromState) => {
              if (
                (fromState.name === 'tasks.leadpopup' &&
                  toState.name === 'tasks') ||
                (fromState.name === 'tasks.unitpopup' &&
                  toState.name === 'tasks')
              ) {
                this.getTasksForTab(this.selectedIndex);
              }
            },
          );
        }, 10);
      }
    });
  }

  getTasksForTab(tabIndex) {
    const usersFilter = {
      'userIds[]': this.selectedUsers.map((item) => item.user_id),
    };

    this.TasksOverview.getAll(
      { ...usersFilter, ...this.tabs[tabIndex].filters },
      (resp) => {
        let tasks = resp;

        if (this.tabs[tabIndex].type === 'today') {
          this.TasksOverview.getAll(
            {
              ...usersFilter,
              solved: 1,
              solvedToday: 1,
            },
            (solvedTasks) => {
              tasks = tasks.concat(solvedTasks);
              this.tasks = tasks;
              this.loaded = true;
            },
          );
        } else {
          this.tasks = tasks;
          this.loaded = true;
        }
      },
    );
  }
}
